import { render } from "./JssColumnManager.vue?vue&type=template&id=fc8495be&scoped=true"
import script from "./JssColumnManager.vue?vue&type=script&lang=js"
export * from "./JssColumnManager.vue?vue&type=script&lang=js"

import "./JssColumnManager.vue?vue&type=style&index=0&id=fc8495be&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8495be"]])

export default __exports__